export default function Home() {
  return (
    <div className='container'>
      <h1>Pers</h1>
      <h2>Track your money how you want</h2>
    </div>
  );
}
